// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1_Lef","cls2":"common-cls2_Kk0 common-cls1_Lef"};